import { render, staticRenderFns } from "./tableOrder.vue?vue&type=template&id=8ccd3eae&scoped=true&"
import script from "./tableOrder.vue?vue&type=script&lang=js&"
export * from "./tableOrder.vue?vue&type=script&lang=js&"
import style0 from "./tableOrder.vue?vue&type=style&index=0&id=8ccd3eae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccd3eae",
  null
  
)

export default component.exports